var table_viewer_default = {
  "root": "hkwqG",
  "viewMode": "_6KEtg",
  "editMode": "cxQLK",
  "container": "NCAKl",
  "tableViewport": "KSwW2",
  "cell": "jj1U2"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
